import type { AnyObject } from '../types/common';

export const localeSortByKeyDesc = <T extends AnyObject>(
  arr: T[],
  sortKey: string,
): T[] => {
  if (arr.length === 0 || !sortKey) {
    return arr;
  }
  return [...arr].sort((a, b) => b[sortKey].localeCompare(a[sortKey]));
};
